import * as React from "react";
import { defined, isEmptyOrUndefined, mapFilterUndefined } from "common/Support";
import { WireBreadcrumbsComponent } from "common/wire";
import { GlideIcon } from "sharedUI/ui/views/glide-icon/glide-icon";
import tw from "twin.macro";
import { WireRenderer } from "webapp/wire-renderers/wire-renderer";
import { getLocalizedString } from "common/components/localization";
import { SectionStyle, useSectionStyle } from "../wire-container/wire-container";

export const Breadcrumbs: WireRenderer<WireBreadcrumbsComponent> = p => {
    const sectionStyle = useSectionStyle();

    return (
        <div css={[sectionStyle === SectionStyle.Accent && tw`all:text-white!`]}>
            <div tw="flex items-center flex-wrap">
                {p.backAction !== undefined && (
                    <button
                        onClick={() => p.backend.runAction(defined(p.backAction?.token), false)}
                        tw="text-text-base mr-8 text-sm hover:(text-text-dark underline) focus-visible:(font-semibold
                            text-text-dark underline) flex items-center">
                        <GlideIcon
                            tw="text-icon-base inline-flex mr-0.5"
                            kind="stroke"
                            icon="st-caret"
                            strokeWidth={2}
                            rotateDeg={90}
                            iconSize={12}
                        />
                        {getLocalizedString("back")}
                    </button>
                )}
                {mapFilterUndefined(p.crumbs, (c, i) => {
                    if (isEmptyOrUndefined(c.title)) return undefined;
                    let onClick: (() => void) | undefined;
                    if (c.action !== undefined) {
                        // FIXME: Handle URL
                        onClick = () => p.backend.runAction(defined(c.action).token, false);
                    }
                    return (
                        <React.Fragment key={i}>
                            <button
                                tw="text-text-base flex-shrink hover:(text-text-dark underline)
                                    focus-visible:(text-text-dark font-semibold underline) text-sm"
                                onClick={onClick}>
                                <span tw="min-w-0 overflow-ellipsis overflow-hidden whitespace-nowrap">{c.title}</span>
                            </button>
                            <GlideIcon
                                tw="text-icon-pale mx-2"
                                kind="stroke"
                                icon="st-caret"
                                strokeWidth={2}
                                rotateDeg={-90}
                                iconSize={12}
                            />
                        </React.Fragment>
                    );
                })}
                <span
                    tw="text-text-base text-sm font-semibold flex-shrink min-w-0 overflow-ellipsis overflow-hidden
                        whitespace-nowrap">
                    {p.currentPageTitle}
                </span>
            </div>
        </div>
    );
};
